import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import type { Publication } from '@/models/publications'

export interface BigCardProps {
  publication: Publication
  publicationType: string
}

export function BigCard({ publication, publicationType }: BigCardProps) {
  return (
    <Link
      to={`/publication/${publication.id_publicacao}`}
      className={twMerge(
        `flex flex-col rounded-md transition`,
        publicationType === 'news'
          ? 'bg-bios-overlay-100 text-publication-news'
          : 'bg-bios-overlay-200 text-bios-500',
      )}
    >
      <div className="space-y-6">
        <img
          src={publication.imagem}
          alt=""
          className="h-64 w-full rounded-t-md object-cover object-center lg:h-96"
        />
        <div className="px-8 pb-10 2xl:px-14">
          <h1 className="line-clamp-2 text-2xl font-bold">
            {publication.titulo}
          </h1>
          <p className="line-clamp-4 text-monochromatic-500">
            {publication.subtitulo}
          </p>
        </div>
      </div>
    </Link>
  )
}
